import {
    MulticurrencyItemModel,
    MulticurrencyModel,
    TransferSummaryModel
} from '../../Models/AmountsWithTransferSummaryModel';

import { fmComponentsContainer } from '../../../topic-components';
import HtmlElementHelper from "../../../../../../../Shared/Helpers/htmlElementHelper";

export default {
    name: "receiver-multicurrency",
    template: "#receiver-multicurrency",
    data: function () {
        return {
            displayDropdown: false,
            filteredItems: [] as Array<MulticurrencyItemModel>,
            selectedItem: {} as MulticurrencyItemModel,
            displayNoResultWarning: false,
            dropdownStyle: {
                width: 0,
                left: 0,
                top: 0
            }
        }
    },
    props: {
        model: Object as () => MulticurrencyModel,
        transferSummaryModel: Object as () => TransferSummaryModel,
        updateCurrencyUrl: String,
    },
    mounted() {
        fmComponentsContainer.$on('closeDropdrownMulticurrencyCtrl', this.handleCloseDropdrownMulticurrencyCtrl);
    },
    watch: {
        model: function (newVal: MulticurrencyModel, _: MulticurrencyModel) {

            this.filteredItems = newVal.Items;
            this.selectedItem = newVal.DefaultSelectedValue;
        }
    },
    methods: {
        filterDropdown: function (event: any) {

            const filteredValue = event.target.value.toUpperCase();

            if (filteredValue == "")
                this.filteredItems = this.model.Items;

            this.filteredItems = this.model.Items.filter((obj: MulticurrencyItemModel) => {
                return obj.ProductName.toUpperCase().includes(filteredValue) || obj.Currency.toUpperCase().includes(filteredValue);
            });
        },
        showDropdown: function () {
            this.displayDropdown = true;

            if (this.displayDropdown) {
                const multiCurrencyElRect = this.$refs.receiverMulticurrency.getBoundingClientRect();

                const form = this.$refs.receiverMulticurrency.closest('form');

                const formElRect = form.getBoundingClientRect();

                this.dropdownStyle.width = formElRect.width;

                this.dropdownStyle.width = formElRect.width;
                this.dropdownStyle.left = formElRect.x - multiCurrencyElRect.x;
                this.dropdownStyle.top = formElRect.top - multiCurrencyElRect.top;
            }
        },
        selectProduct: function (currency: string, sku: string) {

            HtmlElementHelper.g_blockUI();
            this.displayDropdown = false;

            const selectedItem = this.model.Items.find((obj: MulticurrencyItemModel) => {
                return obj.ProductSku === sku && obj.Currency == currency;
            });

            if (selectedItem == null)
                return;

            this.selectedItem = selectedItem;

            const form = new FormData();
            form.append("senderCurrency", this.transferSummaryModel.SentCurrency);
            form.append("receiverCurrency", currency);
            form.append("currencyType", "receiverCurrency");
            form.append("senderAmount", this.transferSummaryModel.AmountSent);
            form.append("product", sku);
            form.append("__RequestVerificationToken", this.requestVerificationToken);

            fetch(this.updateCurrencyUrl, {
                method: 'POST',
                body: form
            })
                .then(response => {
                    return response.json();
                })
                .then(response => {

                    this.$emit('receiverCurrencyUpdated', response);

                    HtmlElementHelper.g_unBlockUI();
                })
                .catch(() => HtmlElementHelper.g_unBlockUI());
        },
        handleCloseDropdrownMulticurrencyCtrl: function () {
            this.displayDropdown = false;
        }
    }
}